<template>
	<div>
		<div class="w">
			<!-- header -->
			<SecondHead activeIndex="7" textColor="#333" color="#333"></SecondHead>
		</div>
		<div style="padding: 20px 20px 50px 20px;border-top: 2px solid #f5f5f5;">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="用户管理" name="1" v-if="permissionList.admin1035">
					<div class="userBox" v-if="activeName == 1">
						<div class="userQuery">
							<div>
								<!-- 搜索 -->
								<el-input size="medium" placeholder="请输入姓名/登录名/手机号" v-model="input3" class="input-with-select">
									<el-button @click="queryName" slot="append" icon="el-icon-search"></el-button>
								</el-input>
								<el-select size="medium" v-model="value" placeholder="请选择用户类型" class="queryUserType" @change="changeType">
									<el-option v-for="item in usertypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
								<el-select size="medium" v-model="value1" placeholder="请选择用户状态" class="queryUserType" @change="changestate">
									<el-option v-for="item in userstateOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</div>
							<el-button size="medium" type="primary" @click="dialogAddFormVisibleOpen">添加用户</el-button>
						</div>
						<div class="userTable">
							<el-table v-loading="loading" border :data="tableData" style="width: 100%">
								<el-table-column fixed align="center" prop="loginname" label="登录名"></el-table-column>
								<el-table-column align="center" prop="nickname" label="姓名"></el-table-column>
								<el-table-column align="center" prop="contactNumber" label="手机号"></el-table-column>
								<el-table-column align="center" prop="usertype" label="用户类型">
									<template slot-scope="scope">
										<span v-if="scope.row.usertype == 1">管理员</span>
										<span v-else>普通用户</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="userstate" label="用户状态">
									<template slot-scope="scope">
										<span v-if="scope.row.userstate == 1">启用</span>
										<span v-else>禁用</span>
									</template>
								</el-table-column>
								<el-table-column align="center" width="200" prop="sysRoles" label="角色">
									<template slot-scope="scope">
										<span class="rolesName" v-for="item in scope.row.sysRoles" :key="item.id">
											{{ item.roleName }}
											<span class="rolesNameDel">
												<el-popconfirm title="确定删除角色吗" @confirm="delroles(scope.row.id, item.id)">
													<i slot="reference" class="el-icon-close"></i>
												</el-popconfirm>
											</span>
										</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="vipendtime" label="VIP到期时间"></el-table-column>
								<el-table-column label="操作" fixed="right" width="300" align="center">
									<template slot-scope="scope">
										<el-link type="primary" :underline="false" style="margin-right: 10px;" @click="editFormData(scope.row)">编辑</el-link>
										<!-- <el-button @click="editFormData(scope.row)" type="text" size="small">编辑</el-button> -->
										<!-- <el-button @click="updateState(scope.row)" type="text" size="small" v-if="adminType == 1">修改用户状态</el-button> -->
										<!-- <el-button @click="updateVipTime(scope.row.id)" type="text" size="small">修改VIP有效期时间</el-button> -->
										
										<el-link type="primary" :underline="false" style="margin-right: 10px;" @click="settingRoles(scope.row)">设置角色</el-link>
										<!-- <el-button @click="settingRoles(scope.row)" type="text" size="small">设置角色</el-button> -->
										<el-popconfirm title="确定重置密码吗？" style="margin-right: 10px;" @confirm="updatepassword(scope.row.id)">
											<!-- <el-button style="margin-left: 10px;" slot="reference" type="text" size="small">重置密码</el-button> -->
											<el-link type="primary" :underline="false" slot="reference">重置密码</el-link>
										</el-popconfirm>
										<el-popconfirm title="确定删除吗？" @confirm="delUserInfo(scope.row.id)">
											<!-- <el-button style="margin-left: 10px;" slot="reference" type="text" size="small">删除用户</el-button> -->
											<el-link type="primary" :underline="false" slot="reference">删除用户</el-link>
										</el-popconfirm>
									</template>
								</el-table-column>
							</el-table>
							<el-pagination
								background
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="inPagination.currentPage"
								:page-sizes="[10, 50, 100, 200, 300, 400]"
								:page-size="inPagination.size"
								layout="total, sizes, prev, pager, next, jumper"
								:total="inPagination.total"
								class="pagination"
							></el-pagination>
						</div>

						<el-dialog title="修改VIP有效日期" :visible.sync="timeVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
							<div><el-date-picker format="yyyy-MM-dd HH:mm:ss" v-model="VipTime" type="datetime" placeholder="选择日期时间"></el-date-picker></div>
							<span slot="footer" class="dialog-footer">
								<el-button size="medium" @click="timeVisible = false">取 消</el-button>
								<el-button size="medium" type="primary" @click="timeOk()">确 定</el-button>
							</span>
						</el-dialog>

						<el-dialog title="修改用户状态" :visible.sync="stateVisible" width="30%" :before-close="handleClose" :close-on-click-modal="false">
							<div>
								<el-radio-group v-model="radioState">
									<el-radio label="1">启用</el-radio>
									<el-radio label="0">禁用</el-radio>
								</el-radio-group>
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button size="medium" @click="stateVisible = false">取 消</el-button>
								<el-button size="medium" type="primary" @click="stateOk()">确 定</el-button>
							</span>
						</el-dialog>
					</div>
				</el-tab-pane>
				<el-tab-pane label="角色" name="2" v-if="permissionList.admin1036"><roleBasedAccessControl v-if="activeName == 2"></roleBasedAccessControl></el-tab-pane>
			</el-tabs>
		</div>
		<!-- 手动添加 -->
		<el-dialog :title="userTitle" :close-on-click-modal="!1" :close-on-press-escape="!1" :visible.sync="dialogAddFormVisible">
			<el-form label-position="right" label-width="80px" ref="add_form" :model="add_form" :rules="rules">
				<el-row>
					<el-col :span="12" v-if="userType == 1">
						<el-form-item label="账号" prop="loginname"><el-input size="medium" v-model="add_form.loginname" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12" v-if="userType == 1">
						<el-form-item label="密码" prop="userppwd"><el-input size="medium" v-model="add_form.userppwd" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="姓名" prop="username"><el-input size="medium" v-model="add_form.username" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="年龄" prop="age"><el-input size="medium" v-model="add_form.age" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别" prop="sex">
							<el-radio-group v-model="add_form.sex">
								<el-radio label="3">未知</el-radio>
								<el-radio label="1">男</el-radio>
								<el-radio label="2">女</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="学历" prop="education"><el-input size="medium" v-model="add_form.education" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号" prop="contactNumber"><el-input size="medium" v-model="add_form.contactNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="邮箱" prop="email"><el-input size="medium" v-model="add_form.email" autocomplete="off"></el-input></el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="身份证号" prop="idNumber"><el-input size="medium" v-model="add_form.idNumber" autocomplete="off"></el-input></el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="用户状态" prop="userstate">
							<el-radio-group v-model="add_form.userstate">
								<el-radio label="1">启用</el-radio>
								<el-radio label="0">禁用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="地址">
							<!-- <el-cascader v-model="region" :options="city" style="width:100%;margin-bottom: 10px;"></el-cascader> -->

							<el-select size="medium" :popper-append-to-body="false" class="Select" v-model="answerArr[0]" placeholder="请选择省份" @change="seleCity($event, 0)">
								<el-option class="SelectOption" v-for="item in address.province" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<!-- 市 -->
							<el-select size="medium" :popper-append-to-body="false" class="Select" v-model="answerArr[1]" placeholder="请选择城市" @change="seleCity($event, 1)">
								<el-option class="SelectOption" v-for="item in address.city" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<!-- 区 / 县 -->
							<el-select size="medium" :popper-append-to-body="false" class="Select" v-model="answerArr[2]" placeholder="请选择区/县" @change="seleCity($event, 2)">
								<el-option class="SelectOption" v-for="item in address.district" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>

							<el-input size="medium" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="add_form.address"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="resetInterviewerPeople('add_form')">取 消</el-button>
				<el-button size="medium" type="primary" @click="handleAddInterviewerPeople('add_form')">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="设置角色" :visible.sync="settingRolesVisible" width="500px" :close-on-click-modal="false">
			<el-select size="medium" v-model="setUser" multiple collapse-tags style="width: 100%;" placeholder="请选择">
				<el-option v-for="item in options" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
			</el-select>
			<span slot="footer" class="dialog-footer">
				<el-button size="medium" @click="settingRolesVisible = false">取 消</el-button>
				<el-button size="medium" type="primary" @click="settingRolesOk">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
//初始化表单数据
function initFormData() {
	return {
		loginname: '',
		username: '',
		age: '',
		education: '',
		contactNumber: '', //手机号
		email: '',
		province: '',
		city: '',
		county: '', //县区
		address: '',
		idNumber: '',
		sex: '3',
		userppwd: ''
	};
}
import SecondHead from '@/components/SecondHead';
import roleBasedAccessControl from '@/page/roleBasedAccessControl.vue';
export default {
	components: {
		SecondHead,
		roleBasedAccessControl
	},
	data() {
		return {
			userType: 1,
			userTitle: '添加用户',
			answerArr: [undefined, undefined, undefined, undefined],
			address: {
				province: [],
				city: [],
				district: []
			},
			adminType: 0,
			permissionList: {},
			city: [],
			settingRolesVisible: false,
			options: [],
			setUser: [],
			activeName: '1',
			dialogAddFormVisible: false,
			add_form: initFormData(),
			rules: {
				loginname: [
					{ required: true, message: '请输入账号！', trigger: 'blur, change' },
				],
				userppwd: [
					{ required: true, message: '请输入密码！', trigger: 'blur, change' },
				],
				username: [ { required: false } ],
				age: [ { required: false } ],
				sex: [ { required: false } ],
				education: [ { required: false } ],
				contactNumber: [ { required: false } ],
				email: [ { required: false } ],
				idNumber: [ { required: false } ],
				userstate: [ { required: false } ],
			},
			edit_form: {},
			radioState: '0',
			stateVisible: false,
			timeVisible: false,
			userId: '',
			VipTime: '',
			inPagination: {
				currentPage: 1,
				size: 10,
				total: 100
			},
			loading: false,
			userstateOptions: [
				{
					value: '',
					label: '请选择用户状态'
				},
				{
					value: '1',
					label: '启用'
				},
				{
					value: '0',
					label: '禁用'
				}
			],
			usertypeOptions: [
				{
					value: '',
					label: '请选择用户类型'
				},
				{
					value: '1',
					label: '管理员'
				},
				{
					value: '2',
					label: '普通用户'
				}
			],
			value1: '',
			input3: '',
			value: '',
			tableData: []
		};
	},
	computed: {
		edit_region: {
			get() {
				let { province, city, county } = this.edit_form;
				return [province, city, county];
			},
			set(value) {
				let [province, city, county] = value;
				this.edit_form = Object.assign({}, this.edit_form, {
					province,
					city,
					county
				});
			}
		},
		region: {
			get() {
				let { province, city, county } = this.add_form;
				return [province, city, county];
			},
			set(value) {
				let [province, city, county] = value;
				this.add_form = Object.assign({}, this.add_form, {
					province,
					city,
					county
				});
			}
		}
	},
	created() {
		this.loadData();
		this.accessPermission();
		this.getProvince();
	},
	methods: {
		cityData(id,index) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryLinkage}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					// console.log(res)
					if (res.code == 0) {
						if (index == 0) {
							that.address.city = res.resultBody.datas;
						} else if (index == 1) {
							that.address.district = res.resultBody.datas;
						}
					}
				}
			};
			this.$util.request(params);
		},
		editFormData(data) {
			this.userTitle = '编辑用户';
			this.userType = 2;
			this.add_form = JSON.parse(JSON.stringify(data));
			this.radioState = this.add_form.userstate;
			console.log(this.add_form);
			if (this.add_form.city != '' && this.add_form.city) {
				this.answerArr = this.add_form.city.split(',');
				if (this.answerArr[0] != '') {
					this.cityData(this.answerArr[0], 0);
				}
				if (this.answerArr[1] != '') {
					this.cityData(this.answerArr[1], 1);
				}
			}

			this.dialogAddFormVisible = true;
		},
		getProvince() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryProvince}`,
				method: 'POST',
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.address.province = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		},
		seleCity(e, index) {
			console.log(e, index);
			if (index == 0 && this.address.city[e]) {
				//存在省下面的市
				return;
			}
			if (index == 1 && this.address.district[e]) {
				//存在市下面的区
				return;
			}
			if (index == 0) {
				this.answerArr[1] = '';
				this.answerArr[2] = '';
				this.answerArr[3] = '';
			} else if (index == 1) {
				this.answerArr[2] = '';
				this.answerArr[3] = '';
			}
			// this.answerArrBlur()
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryLinkage}`,
				method: 'POST',
				data: {
					id: e
				},
				cb(res) {
					// console.log(res)
					if (res.code == 0) {
						if (index == 0) {
							that.address.city = res.resultBody.datas;
						} else if (index == 1) {
							that.address.district = res.resultBody.datas;
						}
					}
				}
			};
			this.$util.request(params);
		},
		dialogAddFormVisibleOpen() {
			this.add_form = {
				loginname: '',
				username: '',
				age: '',
				education: '',
				contactNumber: '', //手机号
				email: '',
				province: '',
				city: '',
				county: '', //县区
				address: '',
				idNumber: '',
				sex: '3',
				userppwd: ''
			};
			this.userTitle = '添加用户';
			this.userType = 1;
			this.answerArr = [undefined, undefined, undefined, undefined];
			this.dialogAddFormVisible = true;
		},
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			console.log(userInfo);
			this.adminType = userInfo.usertype;
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			this.permissionList = permissionList;
			if (permissionList.admin1035) {
				this.activeName = '1';
			} else if (permissionList.admin1036) {
				this.activeName = '2';
			}
		},
		delroles(userId, rolesid) {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.removeRoleToUser}`,
				data: {
					userId: userId,
					roleId: rolesid
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		settingRolesOk() {
			let that = this;
			let strSetUser = JSON.parse(JSON.stringify(that.setUser)).toString();
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.addRoleToUser}`,
				data: {
					userId: that.userId,
					roleId: strSetUser
				},
				cb(res) {
					if (res.code == 0) {
						that.settingRolesVisible = false;
						that.loadData();
						that.setUser = [];
						that.$message.success(res.message);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryingRoles() {
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.queryRole}`,
				data: {
					pageIndex: 1,
					pageSize: 10000,
					roleName: ''
				},
				cb(res) {
					if (res.code == 0) {
						that.options = res.resultBody.records;
						that.settingRolesVisible = true;
					} else {
						that.options = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		settingRoles(data) {
			console.log(data);
			this.setUser = [];
			if (data.sysRoles != '') {
				let roleslistId = [];
				data.sysRoles.forEach(item => {
					roleslistId.push(item.id);
				});
				this.setUser = roleslistId;
			}
			this.userId = data.id;
			this.queryingRoles();
		},
		resetInterviewerPeople(formName) {
			this.$refs[formName].resetFields();
			this.dialogAddFormVisible = false
		},
		handleAddInterviewerPeople(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.add_form.city = this.answerArr.toString();
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					if (this.userType == 1) {
						this.$api
							.AddInterviewerUser(this.add_form)
							.then(data => {
								this.$message({
									message: data.message,
									type: 'success'
								});
							})
							.catch(error => {
								this.$message({
									message: error.message,
									type: 'warn'
								});
							})
							.finally(() => {
								loading.close();
								this.loadData();
								this.resetInterviewerPeople(formName)
							});
					} else {
						this.$api
							.updateoneintervieweruser(this.add_form)
							.then(data => {
								this.$message({
									message: data.message,
									type: 'success'
								});
							})
							.catch(error => {
								this.$message({
									message: error.message,
									type: 'warn'
								});
							})
							.finally(() => {
								loading.close();
								this.loadData();
								this.resetInterviewerPeople(formName)
							});
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});

		},
		updatepassword(id) {
			this.userId = id;
			this.updateUserInfo(this.userId, '', '4', '');
		},
		stateOk() {
			this.updateUserInfo(this.userId, '', '1', this.radioState);
		},
		updateState(data) {
			console.log(data);
			this.userId = data.id;
			this.radioState = data.userstate;
			this.stateVisible = true;
		},
		updateVipTime(id) {
			this.userId = id;
			this.timeVisible = true;
		},
		timeOk() {
			this.updateUserInfo(this.userId, this.VipTime, '2', '');
		},
		handleClose(done) {
			done();
		},
		updateUserInfo(id, endTime, num, status) {
			console.log('id, endTime, num, status',id, endTime, num, status)
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.updateUser}`,
				data: {
					endTime: endTime,
					id: id,
					num: num,
					status: status
				},
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.$message.success(res.message);
						that.userId = '';
						that.VipTime = '';
						that.timeVisible = false;
						that.radioState = '0';
						that.stateVisible = false;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		delUserInfo(id) {
			this.updateUserInfo(id, '', 3, '');
		},
		handleClick(data) {},
		changeType() {
			this.loadData();
		},
		changestate() {
			this.loadData();
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.inPagination.size = val;
			this.loadData();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.inPagination.currentPage = val;
			this.loadData();
		},
		queryName() {
			this.loadData();
		},
		loadData() {
			this.loading = true;
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.selectUsers}?pageIndex=${that.inPagination.currentPage}&pageSize=${that.inPagination.size}`,
				data: {
					pageIndex: that.inPagination.currentPage,
					pageSize: that.inPagination.size,
					name: that.input3,
					status: that.value1,
					type: that.value
				},
				cb(res) {
					if (res.code == 0) {
						that.loading = false;
						that.tableData = res.resultBody.datas;
						that.inPagination.total = res.resultBody.total;
					} else {
						that.tableData = [];
						// that.$message.error(res.message);
						that.loading = false;
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped lang="scss">
.userBox {
	// width: 1200px;
	// margin: 0px auto;
	// padding: 20px 20px 20px 20px;

	.userQuery {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 5px;
		.input-with-select {
			width: 300px;
			margin-right: 20px;
		}
		.queryUserType {
			margin-right: 20px;
		}
	}
	.userTable {
		margin-top: 20px;
		.rolesName {
			padding: 10px;
			position: relative;
			cursor: pointer;
			.rolesNameDel {
				position: absolute;
				right: 0px;
				top: 0px;
			}
			.rolesNameDel:hover {
				color: #0080ff;
			}
		}
		.pagination {
			margin-top: 20px;
			text-align: right;
		}
	}
}
.Select {
	width: 100%;
	margin-bottom: 10px;
}
</style>
